export const GET_NOTE_LIST = 'GET_NOTE_LIST';
export const getNoteList = () => ({
  type: GET_NOTE_LIST,
});

export const CREATE_NOTE_ITEM = 'CREATE_NOTE_ITEM';
export const createNoteItem = message => ({
  type: CREATE_NOTE_ITEM,
  payload: {
    message,
  },
});

export const UPDATE_NOTE_ITEM = 'UPDATE_NOTE_ITEM';
export const updateNoteItem = (id, message) => ({
  type: UPDATE_NOTE_ITEM,
  payload: {
    id,
    message,
  },
});

export const DELETE_NOTE_ITEM = 'DELETE_NOTE_ITEM';
export const deleteNoteItem = id => ({
  type: DELETE_NOTE_ITEM,
  payload: {
    id,
  },
});
